// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3Xv3N","gfeWrapper":"CalendarEvent_gfeWrapper__6sCBJ"};